var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-wrapper p-4"},[_c('label',{staticClass:"text-sm",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._l((_vm.options),function(option,key){return _c('div',{key:key})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }